import { keyframes } from "styled-components";

export const PANEL_ANIMATION_DURATION_MS = 300;
export const PANEL_ANIMATION_DURATION_STRING = `${PANEL_ANIMATION_DURATION_MS}ms`;
export const PANEL_ANIMATION_EASING = "cubic-bezier(0.25, 0.46, 0.45, 0.94)";

// Asymmetric pair for elements that enter and leave: something arriving decelerates into place so the eye can
// follow it, something leaving accelerates away so it does not hold up the interaction.
export const EMPHASIZED_DECELERATE_EASING = "cubic-bezier(0.05, 0.7, 0.1, 1)";
export const EMPHASIZED_ACCELERATE_EASING = "cubic-bezier(0.3, 0, 0.8, 0.15)";

export const fadeInAnimation = keyframes`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;

export const bounceInAnimation = keyframes`
    10%, 20%, 30%, 40%, 50% {
        transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    }

    0% {
        opacity: 0;
        transform: scale3d(.3, .3, .3);
    }
    10% {
        transform: scale3d(1.1, 1.1, 1.1);
    }
    20% {
        transform: scale3d(.9, .9, .9);
    }
    30% {
        opacity: 1;
        transform: scale3d(1.03, 1.03, 1.03);
    }
    40% {
        transform: scale3d(.97, .97, .97);
    }
    50%, 100% {
        opacity: 1;
        transform: scale3d(1, 1, 1);
    }
`;

// macOS-dock "genie": pure scale + opacity so the overlay emerges from / collapses
// into its `transform-origin` (set per-instance to the clicked button). Compositor-only.
export const genieOpenAnimation = keyframes`
    0% {
        opacity: 0;
        transform: scale(0.1);
    }

    100% {
        opacity: 1;
        transform: scale(1);
    }
`;

export const genieCloseAnimation = keyframes`
    0% {
        opacity: 1;
        transform: scale(1);
    }

    100% {
        opacity: 0;
        transform: scale(0.1);
    }
`;
